<template>
  <div class="admin-keyword-detail bg-white-custom border px-3 py-3">
    <b-overlay :show="isLoading" rounded="sm">
      <ConveyRequiredStatement class="mb-2" />
      <div class="admin-keyword-detail--body">
        <b-row>
          <b-col cols="12">
            <b-form-group
              id="fieldset-term"
              label="Term:"
              style="font-weight:500"
              label-for="input-term"
              class="required-form-field"
            >
              <b-form-input
                id="input-term"
                v-model="keyword.term"
                trim
                required
              />
              <b-form-invalid-feedback :state="!!errors['term'] ? false : true">
                {{ errors['term'] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              id="fieldset-level"
              label="Severity Level:"
              style="font-weight:500"
              label-for="radio-group-level"
              class="required-form-field"
            >
              <b-form-radio-group id="radio-group-level" v-model="keyword.level">
                <b-form-radio :value="1">Critical</b-form-radio>
                <b-form-radio :value="2">Major</b-form-radio>
                <b-form-radio :value="3">Minor</b-form-radio>
              </b-form-radio-group>
              <b-form-invalid-feedback :state="!!errors['level'] ? false : true">
                {{ errors['level'] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              id="fieldset-direction"
              label="Direction:"
              style="font-weight:500"
              label-for="checkbox-group-direction"
              class="required-form-field"
            >
              <b-form-checkbox-group id="checkbox-group-direction" v-model="keyword.direction">
                <b-form-checkbox value="caller">Caller</b-form-checkbox>
                <b-form-checkbox value="agent">Agent</b-form-checkbox>
              </b-form-checkbox-group>
              <b-form-invalid-feedback :state="!!errors['direction'] ? false : true">
                {{ errors['direction'] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              id="fieldset-category"
              label="Category:"
              style="font-weight:500"
              label-for="input-category"
              class="required-form-field"
            >
              <b-form-input
                id="input-category"
                v-model="keyword.category"
                trim
              />
              <b-form-invalid-feedback :state="!!errors['category'] ? false : true">
                {{ errors['category'] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              id="fieldset-synonyms"
              label="Synonyms:"
              style="font-weight:500"
              label-for="tags-synonyms"
            >
              
              <b-form-tags id="tags-synonyms" v-model="keyword.synonyms" placeholder="Add synonym..."></b-form-tags>
              <b-form-invalid-feedback :state="!!errors['synonyms'] ? false : true">
                {{ errors['synonyms'] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col v-if="keywordId" cols="12">
            <b-form-group
              id="fieldset-created-at"
              label="Created At:"
              style="font-weight:500"
              label-for="input-created-at"
            >
              <b-form-input id="input-created-at" :value="createdAt" disabled />
            </b-form-group>
          </b-col>
          <b-col v-if="keywordId" cols="12">
            <b-form-group
              id="fieldset-updated-at"
              label="Updated At:"
              style="font-weight:500"
              label-for="input-updated-at"
            >
              <b-form-input id="input-updated-at" :value="updatedAt" disabled />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div class="admin-keyword-detail--footer d-flex align-items-center justify-content-end gap-2">
        <b-button
          variant="success"
          pill
          size="sm"
          :disabled="isSaving || isDeleting || disabledSaveCTA"
          @click="keywordId ? updateKeyword() : addKeyword()"
        >
          <b-spinner v-if="isSaving" small></b-spinner>
          <span v-else>{{ keywordId ? 'Save' : 'Add' }}</span>
        </b-button>
        <b-button
          v-if="keywordId"
          pill
          variant="danger"
          size="sm"
          :disabled="isSaving || isDeleting"
          @click="deleteKeyword()"
        >
          <b-spinner v-if="isDeleting" small></b-spinner>
          <span v-else>Delete</span>
        </b-button>
      </div>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment';
import { mapGetters } from "vuex";
import formatter from "@/mixins/formatter";
import errorHandler from "@/mixins/errorHandler";
import ConveyRequiredStatement from "@/components/ConveyRequiredStatement";

export default {
  name: 'AdminKeywordDetail',
  mixins: [formatter, errorHandler],
  components: { ConveyRequiredStatement },
  props: {
    keywordId: String,
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      isDeleting: false,
      createdAt: null,
      updatedAt: null,
      errors: {},
      originKeyword: {
        term: '',
        level: null,
        synonyms: [],
        category: '',
        direction: [],
      },
      keyword: {
        term: '',
        level: null,
        synonyms: [],
        category: '',
        direction: [],
      },
      fetchAbortController: null,
    };
  },
  computed: {
    ...mapGetters("agency", ["currentAgencyId"]),
    disabledSaveCTA() {
      if (this.keywordId) {
        if (JSON.stringify(this.originKeyword) === JSON.stringify(this.keyword)) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    }
  },
  created() {
    if (this.keywordId) {
      this.fetchKeyword();
    }
  },
  methods: {
    async fetchKeyword() {
      try {
        this.isLoading = true;
        this.fetchAbortController = new AbortController();
        const res = await this.$ConveyApi.keywordsApi.getKeywordById({
          keywordId: this.keywordId,
          signal: this.fetchAbortController.signal
        });
        const {
          term,
          level,
          synonyms,
          category,
          direction,
          created_at,
          updated_at,
        } = res.data.data;
        this.createdAt = this.formattedDate(created_at);
        this.updatedAt = this.formattedDate(updated_at);
        this.originKeyword = {
          term,
          level,
          synonyms: synonyms ? synonyms.split(',') : [],
          category,
          direction: direction ? direction.split(',') : [],
        };
        this.keyword = {
          term,
          level,
          synonyms: synonyms ? synonyms.split(',') : [],
          category,
          direction: direction ? direction.split(',') : [],
        };
      } catch (err) {
        if (!this.isApiCanceled(err)) {
          console.log("[AdminKeywordDetail:fetchKeyword] ERROR: ", err);
        }
      } finally {
        this.isLoading = false;
      }
    },
    validateForm() {
      this.errors = {};
      if (!this.keyword.term) {
        this.errors['term'] = 'Please input term.';
      }
      if (!this.keyword.level) {
        this.errors['level'] = 'Please select a severity level.'
      }
      if (!this.keyword.category) {
        this.errors['category'] = 'Please input category.'
      }
      if (this.keyword.direction.length === 0) {
        this.errors['direction'] = 'Please select direction.'
      }
      if (Object.keys(this.errors).length > 0) {
        return false;
      }
      return true;
    },
    async addKeyword() {
      if (!this.validateForm()) return;

      try {
        this.isSaving = true;
        const { term, level, direction, synonyms, category } = this.keyword;
        const payload = {
          term,
          level,
          category,
          direction: direction && direction.length > 0 ? direction.join(',') : '',
          synonyms: synonyms && synonyms.length > 0 ? synonyms.join(',') : '',
        }
        await this.$ConveyApi.keywordsApi.createKeyword({ payload });
        this.$toastr("success", `Keyword "${term}" has been created.`);
        this.$emit("created");
      } catch(err) {
        console.log('[AdminKeywordDetail:addKeyword] ERROR: ', err);
        this.$toastr("error", "Error occurred adding new keyword to your agency.");
      } finally {
        this.isSaving = false;
      }
    },
    async updateKeyword() {
      if (!this.validateForm()) return;

      try {
        this.isSaving = true;
        const { term, level, direction, synonyms, category } = this.keyword;
        const payload = {
          term,
          level,
          category,
          direction: direction && direction.length > 0 ? direction.join(',') : '',
          synonyms: synonyms && synonyms.length > 0 ? synonyms.join(',') : '',
        }
        await this.$ConveyApi.keywordsApi.updateKeyword({ keywordId: this.keywordId, payload });
        this.$toastr("success", `Keyword has been updated.`);
        this.$emit("updated");
      } catch(err) {
        console.log('[AdminKeywordDetail:updateKeyword] ERROR: ', err);
        this.$toastr("error", "Error occurred updating keyword to your agency.");
      } finally {
        this.isSaving = false;
      }
    },
    async deleteKeyword() {
      if (!confirm(`Are you sure you want to remove "${this.originKeyword.term}" keyword from your agency?`)) {
        return;
      }

      try {
        this.isDeleting = true;
        await this.$ConveyApi.keywordsApi.deleteKeyword({ keywordId: this.keywordId });
        this.$toastr("success", "Keyword has been removed from your agency.");
        this.$emit("deleted");
      } catch(err) {
        console.log("[AdminKeywordDetail:deleteKeyword] ERROR: ", err);
        this.$toastr("error", "Error occurred removing keyword from your agency");
      } finally {
        this.isDeleting = false;
      }
    },
    formattedDate(date) {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const formattedDate = moment.utc(date).tz(tz).format("MMM D, YYYY h:mm a");
      return formattedDate;
    },
  },
  beforeDestroy() {
    if (this.fetchAbortController) {
      this.fetchAbortController.abort();
      this.fetchAbortController = null;
    }
  },
};
</script>

<style lang="scss">
.admin-keyword-detail {
  max-width: 600px;
  width: 100%;
  height: auto;
  border-radius: 1rem;
}
</style>